var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"iframeContainer",staticClass:"h-full h-screen"},[(_vm.emailSignupUrl)?_c('iframe',{staticClass:"w-full h-full",attrs:{"frameborder":"0","src":_vm.emailSignupUrl,"load":"load"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }